// Each column in the CSV file can be matched with our internal columns
// (column_first, column_last, ...). To do so, an user must associate
// an internal column with a column from his CSV (column_0, column_1, ...).
//
// At the end, the hidden inputs (bulk_finder[column_first]...) must contain
// the index of the associated CSV column.
//
// The selects are just there for UI purposes but are not submitted with the
// form.
//

const select_matched_columns_options = function () {
  // for each bulk_finder hidden input
  $('input[id^="bulk_finder_"]').each(function () {
    // we get the name of the column
    const internal_column_name = $(this).attr("id").replace("bulk_finder_", "")

    // and its value
    const internal_column_value = $(this).val()

    // and then we set the selected attribute to the option
    // of the associated select input
    return $('select[id="column_' + internal_column_value + '"] option').each(function () {
      if ($(this).val() === internal_column_name) {
        return $(this).attr("selected", "selected")
      }
    })
  })

  return disable_matched_columns()
}

const update_matching = () =>
  $('select[id^="column_"]').on("change", function () {
    // when there's a change in the matching, we update all the hidden inputs
    $('input[id^="bulk_finder_"]').each(function () {
      const internal_column = $(this)
      const internal_column_name = $(this).attr("id").replace("bulk_finder_", "")

      // was_found will be true if we found a selected value
      // for this internal_column
      let was_found = false

      // we go through all the selects, to find if one has the
      // "internal_column_name" as a selected value
      $('select[id^="column_"]').each(function () {
        if ($(this).find(":selected").val() === internal_column_name) {
          const column_value = $(this).attr("id").replace("column_", "")
          internal_column.val(column_value)
          return (was_found = true)
        }
      })

      // none of the selects have the "internal_column_name" as a
      // selected option, so the internal column does not have
      // any matching
      if (!was_found) {
        return internal_column.removeAttr("value")
      }
    })

    disable_matched_columns()
    return toggle_submit_button_state()
  })

// When a value is selected in any of our selects, it must not be
// selectable in another one
//
var disable_matched_columns = function () {
  const matched_columns = []

  // we save the value of all the matched columns
  $('select[id^="column_"]').each(function () {
    return matched_columns.push($(this).val())
  })

  // we loop through the option of each selects
  return $('select[id^="column_"]')
    .children("option")
    .each(function () {
      const value = $(this).val()

      // the option must be disabled if it's in the matched columns
      // and it's selected in another select
      if (value === "" || value === $(this).parent("select").val() || !Array.from(matched_columns).includes(value)) {
        return $(this).removeAttr("disabled")
      } else {
        return $(this).attr("disabled", true)
      }
    })
}

const listen_for_first_line_toggle = () =>
  $('input[id="bulk_finder_header_row"]').on("change", () => toggle_first_line_display())

// Show or hide the first tr depending on if the checkbox is checked or not
//
var toggle_first_line_display = function () {
  if ($('input[id="bulk_finder_header_row"]').is(":checked")) {
    return $('tr[class="first"]').fadeOut()
  } else {
    return $('tr[class="first"]').fadeIn()
  }
}

// Returns true if all the columns were matched and no "first", "last" or
// "full_name" option were selected, false otherwise
const all_columns_matched_and_no_names = function () {
  let matched_columns = 0

  $('input[id^="bulk_finder_column_"]').each(function () {
    if ($(this).val()) {
      return (matched_columns += 1)
    }
  })

  if (matched_columns !== $('select[id^="column_"]').length) {
    return false
  }

  return (
    $("#bulk_finder_column_first").val() === "" &&
    $("#bulk_finder_column_last").val() === "" &&
    $("#bulk_finder_column_name").val() === ""
  )
}

// Enable or disable the submit button depending on if the required
// matchings are done or not
//
var toggle_submit_button_state = function () {
  const first = $("#bulk_finder_column_first").val().length > 0
  const last = $("#bulk_finder_column_last").val().length > 0
  const name = $("#bulk_finder_column_name").val().length > 0
  const company = $("#bulk_finder_column_company").val().length > 0
  const domain = $("#bulk_finder_column_domain").val().length > 0

  if (((first && last) || name) && (company || domain)) {
    $('button[type="submit"]').removeAttr("disabled")
    $("#missing-names").hide()
    return $("#matching-not-ok").hide()
  } else {
    $('button[type="submit"]').attr("disabled", "disabled")

    if (all_columns_matched_and_no_names()) {
      $("#missing-names").show()
      return $("#matching-not-ok").hide()
    } else {
      $("#missing-names").hide()
      return $("#matching-not-ok").show()
    }
  }
}

document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("configuration", "bulk_finders")) {
    return
  }

  // Selet the matched columns options with values from the model
  select_matched_columns_options()

  // Update the hidden form fields with the selected matching values
  update_matching()

  // Display the first line or not if it contains the headers
  listen_for_first_line_toggle()

  // Handle the state of the matching button
  return toggle_submit_button_state()
})
